<template>
    <BaseDialog
        :showDialog="showFileBulkImportDialog"
        maxDialogWidth="950"
        headline="lang_GENERAL_BUTTON_UPLOAD_FILES"
        :close="closeDialog"
        maxCardHeight="1110"
        :scrollable="false"
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid> 
                <v-row>
                    <v-col :alvqa="alvqa + '-file-uploader'">
                        <FileUploader ref="fileUploader"></FileUploader>
                    </v-col>
                </v-row>
            </v-container>
        </template>

        <template v-slot:actionsWithValidation>
            <ValidationObserver
                slim
                ref="FileBulkUploaderValidation"
                v-slot="{ passes}"
            >
            <v-card-actions class="pt-0 pb-0 pr-6 pl-6">
                <v-container fluid>
                    <v-row>
                        <v-col cols="6">
                            <BaseEditPageTextField 
                                :context="context"
                                field="Tag"
                                :clearable="false"
                                :disabled="!show ||readonly"
                                :label="tagPrefixLabel"
                                :alvqa="alvqa + '-textfield-tag'"
                            />
                        </v-col>
                        <v-col cols="6">
                            <BaseEditPageDropdown
                                :label="labelCompanyLabel" 
                                :items="getLabelsItems"
                                :context="context"
                                field="SelectedLabelId"
                                :clearable="false"
                                itemText="name_alv" 
                                itemValue="alvId" 
                                rules="required"
                                :alvqa="alvqa + '-dropdown-selected-label'"
                            />
                        </v-col>
                    </v-row>
                    <v-row class="pa-0">  
                        <v-spacer />
                        <v-col
                            class="text-right" 
                            align-self="center"
                        >
                            <BaseButton 
                                @click="passes(uploadFiles)"
                                :disabled="uploadButtonCondition"
                                label="lang_GENERAL_BUTTON_UPLOAD_FILES"
                                :alvqa="alvqa + '-button-upload'"
                            />
                        </v-col>
                    </v-row>  
                </v-container>
            </v-card-actions>
            </ValidationObserver>
        </template>
    </BaseDialog>
</template>

<script>
import api2 from '@/api_alv'
import BaseDialog from '../_base/BaseDialog'
import BaseEditPageTextField from '../_editForm/BaseEditPageTextField'
import BaseButton from '../_buttons/BaseButton'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import FileUploader from '../FileUploader'

export default {
    name: 'FileBulkUploadDialog',
    components: {
        BaseDialog,
        BaseButton,
        FileUploader,
        BaseEditPageTextField,
        BaseEditPageDropdown
    },
    data() {
        return {
            showDialog: false,
            context: 'FileBulkUploader',
            alvqa: "file-bulk-upload-dialog"
        }
    },
    computed: {
        labelCompanyLabel() { 
            return this.$t('lang_LABEL_TRACKS_CAPTION_LABEL') 
        },
        tagPrefixLabel() {
            return this.$t('lang_LABEL_TRACKS_ACTION_BULK_FILE_IMPORT_TAG_FIELD')
        },
        uploadButtonCondition() {
            return !this.show || this.readonly || this.fileRecordsForUpload.length == 0
        },
        showFileBulkImportDialog: {
            get() { return this.$store.getters.getShowFileBulkImportDialog },
            set(showFileImportDialog) { this.$store.commit('setShowFileBulkImportDialog', showFileImportDialog) }
        },
        fileRecords: {
            get() { return this.$store.getters.getSelectedFileRecordsBulkImport },
            set( item ) { this.$store.commit('setSelectedFileRecordsBulkImport', item)},
        },
        data: {
            get() { return this.$store.getters.getSelectedFileReportDataBulkImport },
            set( item ) { this.$store.commit('setSelectedFileReportDataBulkImport', item)},
        },
        show: {
            get() { return this.$store.getters.getSelectedFileBulkImportUploader },
            set( item ) { this.$store.commit('setSelectedFileBulkImportUploader', item)},
        },
        fileRecordsForUpload: {
            get() { return this.$store.getters.getFileBulkUploaderFileRecordsForUpload },
            set( item ) { this.$store.commit('setFileBulkUploaderFileRecordsForUpload', item)},
        },
        
        uploadUrl: {
            get() { return this.$store.getters.getFileBulkUploaderUploadUrl },
            set( item ) { this.$store.commit('setFileBulkUploaderUploadUrl', item)},
        },
        
        uploadHeaders: {
            get() { return this.$store.getters.getFileBulkUploaderUploadHeaders },
            set( item ) { this.$store.commit('setFileBulkUploaderUploadHeaders', item)},
        },

        deletable: {
            get() { return this.$store.getters.getFileBulkUploaderDeletable },
            set( item ) { this.$store.commit('setFileBulkUploaderDeletable', item)},
        },

        readonly: {
            get() { return this.$store.getters.getFileBulkUploaderReadonly },
            set( item ) { this.$store.commit('setFileBulkUploaderReadonly', item)},
        },
        
        tag: {
            get() { return this.$store.getters.getFileBulkUploaderDetailsTag },
            set( item ) { this.$store.commit('setFileBulkUploaderDetailsTag', item)},
        },

        getLabelsItems() { 
            let itemsFromDb = this.$store.getters.getFileBulkUploaderLabelsDropdown 
            itemsFromDb.forEach(item => {
                item['alvqa'] = this.alvqa + '-label-dropdown-' + item.id
            })
            return itemsFromDb
        },
        
        getSelectedLabelId() { return this.$store.getters.getFileBulkUploaderDetailsSelectedLabelId }
    },
    methods: {
        closeDialog() { 
            if(this.readonly) {
                return;
            }
            this.$nextTick(() => {
                this.showFileBulkImportDialog = false    
                this.$store.commit('setSelectedFileRecordsBulkImport', [])
                this.$store.commit('setSelectedFileReportDataBulkImport', [])
                // this.$store.commit('setFileBulkUploaderDetailsSelectedLabelId', [])
                this.$store.commit('setSelectedFileBulkImportUploader', true)
                this.fileRecordsForUpload = [];
                this.$store.commit('setSelectedFileBulkImport', [])
                this.readonly = false;
                this.deletable = true;
                this.tag = "";
            });
        },
        uploadFiles() {
            if(this.fileRecordsForUpload.length == 0) {
                return
            }

            this.deletable = false
            this.readonly = true
            this.uploadHeaders = {
                Authorization: "Bearer " + this.$store.getters.getUserToken()
            }
            this.uploadUrl = api2.getFileBulkUploadUrl()
            var _this = this;
            this.$refs.fileUploader.$refs.vueFileAgent.upload(
                this.uploadUrl,
                this.uploadHeaders,
                this.fileRecordsForUpload,
                function createFormData(fileData){
                    var formData = new FormData();
                    formData.append('userTags', _this.tag);
                    formData.append('labelAlvId', _this.getSelectedLabelId);
                    formData.append('file', fileData.file); // this is important! - the actual file for upload
                    return formData;
                }
            );
            this.fileRecordsForUpload = [];
        }
    }
}
</script>